import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const data = await exchangeGoogleSession(sessionId);
        // Clear the fragment
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: data.user } });
      } catch (_err) {
        navigate('/login?error=google', { replace: true });
      }
    })();
  }, [exchangeGoogleSession, navigate, location.hash]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-cream">
      <Loader2 className="w-8 h-8 animate-spin text-mahogany" />
      <p className="mt-4 text-burgundy font-serif-display text-xl">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
